import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import manage from '@/constants/manage';
import FileUpload from '@/components/FileUpload/FileUpload';
import { valsubstr32addbr, saveFile } from '@/utils/index';
import windowHeightMixin from '@/mixins/windowHeightMixin';
export default {
  components: {
    FileUpload: FileUpload
  },
  mixins: [windowHeightMixin],
  props: {
    basicInfoFormData: {
      required: true,
      type: Object
    },
    rolePermissions: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      downloadErrorDialogVisible: false,
      errorFile: {},
      userLabelRuleId: '',
      dictList: JSON.parse(sessionStorage.getItem('dist_info')),
      dictInfo: '',
      userOptions: [],
      userOptionLoading: false,
      bizLineList: [],
      filterForm: {
        userId: [],
        orgMap: [],
        manageOrgMap: [],
        bizLineList: []
      },
      rule: '',
      rules: [],
      autoUsers: [],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      userFilterData: {
        orgMap: [],
        manageOrgMap: [],
        bizLineList: []
      },
      uploadDialogShow: false,
      fileList: [],
      singleUserForm: {
        userId: '',
        userName: '',
        mngLevel: '',
        position: '',
        org: '',
        corner: 'A',
        manageOrgList: [],
        bizLineList: []
      },
      updateUserDialogShow: false,
      submitFlag: false,
      topId: manage.HEAD_ORG_ID
    };
  },
  created: function created() {
    this.getRules();
    this.getBusLines();
    var userLabelRuleId = this.basicInfoFormData.userLabelRuleId;
    this.userLabelRuleId = userLabelRuleId;
    if (this.userLabelRuleId) {
      this.previewUser(1, 10);
    }
  },
  methods: {
    // 获取条线列表数据
    getBusLines: function getBusLines() {
      this.dictInfo = this.dictList.BUSINESS_LINE || null;
      var obj = this.dictInfo;
      if (this.dictInfo !== null) {
        // eslint-disable-next-line guard-for-in
        for (var i in obj) {
          this.bizLineList.push({
            key: i,
            value: obj[i]
          });
        }
      }
    },
    // 获取筛选人员规则数据
    getRules: function getRules() {
      var _this = this;
      this.$API.getRequest({
        url: '/platform/userRule/systemId',
        data: {
          systemId: this.basicInfoFormData.systemId
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this.rules = Array.isArray(res.result) && res.result;
        }
      });
    },
    // 预览人员信息
    previewUser: function previewUser() {
      var _this2 = this;
      var pageNum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
      if (!this.userLabelRuleId) {
        this.$message.warning('请先选择人员规则！');
        return;
      }
      var data = {
        bizLineList: this.filterForm.bizLineList || [],
        manageOrgList: this.filterForm.manageOrgMap || [],
        orgIdList: this.filterForm.orgMap || [],
        pageNum: pageNum,
        pageSize: pageSize,
        systemId: this.basicInfoFormData.systemId || [],
        userIdList: this.filterForm.userId || [],
        userLabelRuleId: this.userLabelRuleId,
        roleId: this.basicInfoFormData.roleId
      };
      this.$API.postRequest({
        url: '/platform/autoUser/list',
        data: data
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this2.autoUsers = Array.isArray(res.result.records) && res.result.records;
          _this2.autoUsers.forEach(function (item) {
            item.mngLevel = _this2.dictList.MANAGER_LEVEL[item.mngLevel];
          });
          _this2.pagination.total = res.result.total;
        }
      });
    },
    // 编辑用户，数据回显
    editUser: function editUser(scope) {
      var user = scope.row;
      var userName = user.userName,
        mngLevel = user.mngLevel,
        jobNameList = user.jobNameList,
        pathName = user.pathName,
        corner = user.corner,
        manageOrgList = user.manageOrgList,
        bizLineList = user.bizLineList,
        orgId = user.orgId,
        userId = user.userId;
      this.singleUserForm = {
        userId: userId,
        userName: userName,
        mngLevel: mngLevel,
        position: jobNameList,
        org: pathName,
        corner: corner,
        manageOrgList: manageOrgList,
        bizLineList: bizLineList,
        orgId: orgId
      };
      this.updateUserDialogShow = true;
    },
    confirmUpdateUser: function confirmUpdateUser() {
      var _this3 = this;
      this.$refs.userForm.validate(function (valid) {
        if (valid) {
          var _this3$basicInfoFormD = _this3.basicInfoFormData,
            autoComputeArea = _this3$basicInfoFormD.autoComputeArea,
            canSetBizLine = _this3$basicInfoFormD.canSetBizLine,
            roleId = _this3$basicInfoFormD.roleId,
            canSetManageOrg = _this3$basicInfoFormD.canSetManageOrg,
            systemId = _this3$basicInfoFormD.systemId;
          var _this3$singleUserForm = _this3.singleUserForm,
            bizLineList = _this3$singleUserForm.bizLineList,
            manageOrgList = _this3$singleUserForm.manageOrgList,
            orgId = _this3$singleUserForm.orgId,
            corner = _this3$singleUserForm.corner,
            userId = _this3$singleUserForm.userId;
          var payload = {
            autoComputeArea: autoComputeArea,
            bizLineList: bizLineList,
            canSetBizLine: canSetBizLine,
            canSetManageOrg: canSetManageOrg,
            corner: corner,
            manageOrgList: manageOrgList,
            orgId: orgId,
            roleId: roleId,
            userId: userId,
            systemId: systemId
          };
          _this3.$API.putRequest({
            url: '/platform/autoUser',
            data: payload
          }).then(function (res) {
            if (res.code === '0000000000') {
              _this3.$message.success('用户信息已存放在固定用户列表内，请知悉!');
              _this3.updateUserDialogShow = false;
              _this3.previewUser(1, 10);
              // 更新固定列表用户
              _this3.$EventBus.$emit('updateCustomizedUsers', {
                needUpdate: true
              });
            }
          });
        }
      });
    },
    // 获取筛选条件数据
    getUserFilterData: function getUserFilterData() {
      var _this4 = this;
      var systemId = this.basicInfoFormData.systemId;
      this.$API.getRequest({
        url: '/platform/autoUser/conditions',
        data: {
          userLabelRuleId: this.userLabelRuleId,
          systemId: systemId
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          var _res$result = res.result,
            bizLineList = _res$result.bizLineList,
            manageOrgMap = _res$result.manageOrgMap,
            orgMap = _res$result.orgMap;
          _this4.userFilterData.bizLineList = _this4.bizLineList.filter(function (item) {
            return bizLineList.includes(item.key);
          });
          _this4.userFilterData.manageOrgMap = manageOrgMap;
          _this4.userFilterData.orgMap = orgMap;
        }
      });
    },
    resetFilterConfirm: function resetFilterConfirm() {
      this.filterForm = {
        userId: [],
        orgMap: [],
        manageOrgMap: [],
        bizLineList: []
      };
    },
    /**
     * @description 用户数据联想请求
     * @param {String} val 输入值
     * @return {void}
     * @author 🦉Owllai🦉 2022/06/14
     */
    userRemoteMethod: function userRemoteMethod(val) {
      var _this5 = this;
      if (val === '') {
        return;
      }
      this.userOptionLoading = true;
      this.$API.getRequest({
        url: "/platform/component/userNameOrId/".concat(val),
        data: {}
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this5.userOptions = res.result;
        }
      }).finally(function () {
        _this5.userOptionLoading = false;
      });
    },
    /**
     * @description 根据联想数据自动带出用户默认信息
     * @param {String} val 用户编号
     * @return {void}
     * @author 🦉Owllai🦉 2022/06/14
     */
    setUserDefaultInfo: function setUserDefaultInfo(val) {
      this.singleUserForm.userId = val;
      var selectedUser = this.userOptions.find(function (user) {
        return user.userId === String(val);
      });
      this.singleUserForm.userName = selectedUser.userName;
      this.singleUserForm.mngLevel = selectedUser.mngLevel;
      this.singleUserForm.position = selectedUser.jobList.map(function (jobItem) {
        return jobItem.jobName;
      }).join(',');
      this.singleUserForm.org = selectedUser.orgName;
      this.singleUserForm.orgId = selectedUser.orgId;
    },
    // pageNum 回调事件
    currentChange: function currentChange(value) {
      this.pagination.pageNum = value;
      this.previewUser(this.pagination.pageNum, this.pagination.pageSize);
    },
    // pageSize 回调事件
    sizeChange: function sizeChange(value) {
      this.pagination.pageNum = 1;
      this.pagination.pageSize = value;
      this.previewUser(this.pagination.pageNum, this.pagination.pageSize);
    },
    // 导出按钮
    exportUsers: function exportUsers() {
      var _this6 = this;
      var _this$pagination = this.pagination,
        pageNum = _this$pagination.pageNum,
        pageSize = _this$pagination.pageSize;
      var _this$basicInfoFormDa = this.basicInfoFormData,
        roleId = _this$basicInfoFormDa.roleId,
        systemId = _this$basicInfoFormDa.systemId;
      var _this$filterForm = this.filterForm,
        bizLineList = _this$filterForm.bizLineList,
        manageOrgList = _this$filterForm.manageOrgMap,
        userIdList = _this$filterForm.userId;
      this.$API.postRequest({
        url: '/platform/autoUser/list/export',
        data: {
          bizLineList: bizLineList,
          manageOrgList: manageOrgList,
          orgIdList: this.orgMap,
          pageNum: pageNum,
          pageSize: pageSize,
          roleId: roleId,
          userIdList: userIdList,
          systemId: systemId,
          userLabelRuleId: this.userLabelRuleId
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          return res.result;
        }
      }).then(function (_ref) {
        var filePath = _ref.filePath,
          exportMessage = _ref.exportMessage;
        if (!filePath) {
          if (exportMessage) {
            _this6.$message({
              message: exportMessage,
              type: 'success'
            });
          }
          return;
        }
        _this6.$API.getRequest({
          url: '/platform/file/templateDownload',
          data: {
            filePath: filePath
          },
          responseType: 'blob'
        }).then(function (res) {
          saveFile(res.data, '动态用户列表导出文件.xlsx');
        });
      });
    },
    // 下载模板
    downloadTpl: function downloadTpl() {
      this.$API.getRequest({
        url: '/platform/file/templateDownload',
        data: {
          filePath: 'lc/template/批量维护固定用户模板.xlsx'
        },
        responseType: 'blob'
      }).then(function (res) {
        saveFile(res.data, '批量维护动态用户模板.xlsx');
      });
    },
    // 筛选弹窗 ‘确定’按钮点击事件
    filterConfirm: function filterConfirm() {
      this.previewUser(1, 10);
      this.$refs['filter-popover'].doClose();
    },
    // 批量维护用户 文件上传成功回调函数
    uploadSuccess: function uploadSuccess(fileList) {
      this.fileList = fileList;
      if (this.userLabelRuleId) {
        this.previewUser(1, 10);
      }
      // 更新固定列表用户
      this.$EventBus.$emit('updateCustomizedUsers', {
        needUpdate: true
      });
    },
    uploadError: function uploadError(response) {
      this.errorFile = response;
      this.downloadErrorDialogVisible = true;
    },
    downloadError: function downloadError() {
      var _this7 = this;
      this.$API.getRequest({
        url: '/platform/file/templateDownload',
        data: {
          filePath: this.errorFile.message
        },
        responseType: 'blob'
      }).then(function (res) {
        saveFile(res.data, _this7.errorFile.message);
      });
    },
    // '批量维护用户' 按钮点击事件
    handleUploadUser: function handleUploadUser() {
      this.uploadDialogShow = true;
    },
    handleConfirmUpload: function handleConfirmUpload() {
      this.$message({
        type: 'success',
        message: '上传成功，固定用户列表已更新！'
      });
      this.fileList = [];
      this.uploadDialogShow = false;
    },
    confirmCancel: function confirmCancel(flag) {
      flag && this.$router.push({
        path: '/system/role'
      });
    },
    submit: function submit() {
      var _this8 = this;
      if (this.submitFlag) {
        return;
      }
      this.submitFlag = true;
      this.basicInfoFormData.userLabelRuleId = this.userLabelRuleId;
      this.$API.putRequest({
        url: '/platform/roleInner/autoUser/',
        data: this.basicInfoFormData
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this8.submitFlag = true;
          _this8.$message.success('提交成功！');
        }
      });
    },
    userSelectChange: function userSelectChange() {},
    orgHandle: function orgHandle() {},
    ToBreak: function ToBreak(val) {
      if (val) {
        return valsubstr32addbr(val);
      }
    }
  }
};